import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ButtonCustom from '../../atoms/button/ButtonCustom.jsx'
import CommonModal from '../../atoms/modal/CommonModal.jsx'
import { closeModal, setModalData } from '../../../features/commonSlice.js'
import {
	getKazooProposals,
	requestBidRevision,
	updateProposal,
} from '../../../features/proposalSlice.js'
import styles from './ProposalPopup.module.scss'
import TextArea from '../../atoms/textarea/TextArea.jsx'
import { useNavigate } from 'react-router-dom'

const ApproveIcon = () => (
	<svg
		width="56"
		height="56"
		viewBox="0 0 56 56"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="28" cy="28" r="28" fill="#C8E6C9" />
		<path
			d="M28 41.3333C35.3333 41.3333 41.3333 35.3333 41.3333 28C41.3333 20.6666 35.3333 14.6666 28 14.6666C20.6667 14.6666 14.6667 20.6666 14.6667 28C14.6667 35.3333 20.6667 41.3333 28 41.3333Z"
			stroke="#4CAF50"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M22.3333 28L26.1067 31.7734L33.6667 24.2267"
			stroke="#4CAF50"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
)

const RejectIcon = () => (
	<svg
		width="56"
		height="56"
		viewBox="0 0 56 56"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="28" cy="28" r="28" fill="#FCC5C1" />
		<path
			d="M28 41.3333C35.3333 41.3333 41.3333 35.3333 41.3333 28C41.3333 20.6666 35.3333 14.6666 28 14.6666C20.6667 14.6666 14.6667 20.6666 14.6667 28C14.6667 35.3333 20.6667 41.3333 28 41.3333Z"
			stroke="#F44336"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M24.2267 31.7734L31.7733 24.2267"
			stroke="#F44336"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M31.7733 31.7734L24.2267 24.2267"
			stroke="#F44336"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
)

const CancelIcon = () => (
	<svg
		width="56"
		height="56"
		viewBox="0 0 56 56"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="28" cy="28" r="28" fill="#FFE0BA" />
		<path
			d="M28 41.3333C35.3333 41.3333 41.3333 35.3333 41.3333 28C41.3333 20.6666 35.3333 14.6666 28 14.6666C20.6667 14.6666 14.6667 20.6666 14.6667 28C14.6667 35.3333 20.6667 41.3333 28 41.3333Z"
			stroke="#FF9B21"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M24.2267 31.7734L31.7734 24.2267"
			stroke="#FF9B21"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M31.7734 31.7734L24.2267 24.2267"
			stroke="#FF9B21"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
)

const MODAL_CONFIG = {
	approveProposal: {
		heading: 'Approve Bid',
		subHeading: 'Are you sure you want to Approve this Bid request?',
		actionLabel: 'Approve Bid',
		variant: 'approve',
		status: 'Approved',
		showInput: false,
		icon: <ApproveIcon />,
		iconBg: 'var(--success-light, rgba(76,175,80,0.1))',
	},
	rejectProposal: {
		heading: 'Reject Bid',
		subHeading: 'Are you sure you want to Reject this Bid request?',
		actionLabel: 'Reject Bid',
		variant: 'destructive',
		status: 'Declined',
		showInput: true,
		inputHint: 'Let the vendor know why you are rejecting the bid.',
		inputPlaceholder: 'Write here',
		icon: <RejectIcon />,
	},
	revisionProposal: {
		heading: 'Request Revision',
		subHeading: 'Are you sure you want to Request Revision for this Bid?',
		actionLabel: 'Request Revision',
		variant: 'default',
		status: 'Revision',
		showInput: true,
		inputHint: 'Let the vendor know what changes are needed.',
		inputPlaceholder: 'Write here',
	},
	removeProposal: {
		heading: 'Cancel Request',
		subHeading: 'Are you sure you want to cancel this Proposal request?',
		cancelLabel: 'No',
		actionLabel: 'Yes',
		variant: 'destructive',
		status: 'Deleted',
		showInput: false,
		icon: <CancelIcon />,
	},
	cancelRevisionRequest: {
		heading: 'Cancel Revision Request',
		subHeading: 'Are you sure you want to cancel this Revision request?',
		cancelLabel: 'No',
		actionLabel: 'Yes',
		variant: 'destructive',
		status: 'Submitted',
		showInput: false,
		icon: <CancelIcon />,
	},
	editRevisionRequest: {
		heading: 'Edit Revision',
		cancelLabel: 'No',
		actionLabel: 'Yes',
		variant: 'default',
		status: 'Revision',
		showInput: true,
		inputHint: "Describe the changes you'd like...",
		inputPlaceholder: 'Write here',
	},
	deleteProposal: {
		heading: 'Remove From List',
		subHeading:
			'Are you sure you want to remove this Proposal from the list?',
		cancelLabel: 'No',
		actionLabel: 'Yes',
		variant: 'destructive',
		status: 'Deleted',
		showInput: true,
		inputHint: 'Let the vendor know why you are removing the proposal.',
		inputPlaceholder: 'Write here',
		icon: <RejectIcon />,
	},
	cancelProposal: {
		heading: 'Cancel Proposal',
		subHeading: 'Are you sure you want to cancel this Proposal request?',
		cancelLabel: 'No',
		actionLabel: 'Yes',
		variant: 'destructive',
		status: 'Deleted',
		showInput: false,
		icon: <CancelIcon />,
	},
	withdrawProposal: {
		heading: 'Withdraw Proposal',
		subHeading: 'Are you sure you want to withdraw this Proposal request?',
		cancelLabel: 'No',
		actionLabel: 'Yes',
		variant: 'destructive',
		status: 'Declined',
		showInput: false,
		icon: <CancelIcon />,
	},
}

export const ProposalPopup = ({ kazooData }) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [reason, setReason] = useState('')
	const modal = useSelector((s) => s.common.modal)

	const config = MODAL_CONFIG[modal] ?? null
	const isOpen = Boolean(config)

	useEffect(() => {
		if (modal === 'editRevisionRequest')
			setReason(kazooData?.revision_description ?? '')
		else if (!!reason) setReason('')
	}, [modal])

	const closeModals = () => {
		setReason('')
		dispatch(closeModal())
		dispatch(setModalData(null))
	}

	const handleAction = () => {
		if (!config) return
		const text = reason.trim()
		const payload = { proposalId: kazooData.id, status: config.status }
		if (config.status === 'Revision') {
			payload.revision_description = text
			dispatch(requestBidRevision(payload)).then(() => {
				dispatch(getKazooProposals(kazooData?.kazooId))
				closeModals()
			})
		} else {
			if (config.showInput && text) payload.reason = text
			else if (config.status === 'Deleted')
				payload.reason = 'Proposal Deleted'
			dispatch(updateProposal(payload)).then(() => {
				if (modal === 'withdrawProposal')
					navigate('/vendor-proposal?tab=my-bids')
				else dispatch(getKazooProposals(kazooData?.kazooId))
				closeModals()
			})
		}
	}

	return (
		<CommonModal
			open={isOpen}
			handleClose={closeModals}
			heading={config?.heading}
			subHeading={config?.subHeading}
			headerIcon={config?.icon}
			subclass={true}
			footerContent={
				<div
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'center',
						gap: '12px',
						alignItems: 'center',
					}}
				>
					<ButtonCustom
						variant="outlined"
						type="button"
						size="lg"
						onClick={closeModals}
					>
						{config?.cancelLabel ?? 'Cancel'}
					</ButtonCustom>
					<ButtonCustom
						variant={config?.variant}
						size="lg"
						onClick={handleAction}
						data-cy="proposal-modal-confirm"
					>
						{config?.actionLabel}
					</ButtonCustom>
				</div>
			}
		>
			{config?.showInput && (
				<div
					className={
						config.status !== 'Revision' ? styles.inputBox : ''
					}
				>
					<p className={styles.inputHint}>{config.inputHint}</p>
					<TextArea
						value={reason}
						onChange={(e) => setReason(e.target.value)}
						placeholder={config.inputPlaceholder}
						rows={4}
						className={styles.input}
					/>
				</div>
			)}
		</CommonModal>
	)
}
